import React from 'react';
import { translate } from 'react-i18next';
import AdminStepCard from '../../../components/AdminStepCard/AdminStepCard';
import TextInput from '../../../components/TextInput/TextInput';
import './SettingInformationCard.scss'


const SettingInformationCard = ({
    isErrorInName, action, setting, handleSettingPropChange, ...props
}) => {
    const { t: translate } = props;
    const t = (prop) => translate(`workplanManager:settings.${prop}`);
    const handleNameChange = (e) => handleSettingPropChange('name', e.target.value);
    const handleDescriptionChange = (e) => handleSettingPropChange('description', e.target.value);

    return (
        <AdminStepCard avatar={1} title={t('info')} >
            <TextInput
                className="name-input"
                error={isErrorInName}
                value={setting.name}
                label={t('name')}
                onChange={handleNameChange}
                inputProps={{ maxLength: 50 }}
                size="lg"
            />
            <div className='disclaimer'><small >{t('nameDisclaimer')}</small></div>
            <TextInput
                className="description-input"
                multiline={true}
                rows={4}
                value={setting.description}
                label={t('description')}
                onChange={handleDescriptionChange}
                inputProps={{ maxLength: 50 }}
                placeholder={t('descPlaceHolder')}
                size="lg"
            />
            <div className='disclaimer'><small>{t('descDisclaimer')}</small></div>
        </AdminStepCard>
    )
}

export default translate('workplanManager')(SettingInformationCard);
